/**
 * Build a shareable invitation signup URL for a user signup code.
 * Uses the current origin so SG/AU/local environments all get the right host.
 */
export const getInvitationSignupUrl = (code) => {
  const trimmed = String(code || '').trim();
  if (!trimmed) return '';
  const origin =
    typeof window !== 'undefined' && window.location?.origin
      ? window.location.origin
      : '';
  return `${origin}/register/invitation/${encodeURIComponent(trimmed)}`;
};
